import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import Home from '../views/Home.vue';
import Login from '@/views/login/Login.vue';
import Index from '@/views/index/Index.vue';
import {ElMessage} from 'element-plus';
import StorageUtil from '@/utils/StorageUtil';
import Page404 from '@/views/404/Index.vue';
import GoodsManager from '@/views/goods/usermanager/index.vue';
import AddGoods from '@/views/goods/usermanager/add/add.vue';
import UserManager from '@/views/user/usermanager/index.vue';
import EditShop from '@/views/goods/usermanager/edit/add.vue';
import Order from '@/views/order/usermanager/index.vue';
import Jifenduihuan from '@/views/user/jifenduihuan/index.vue';
import System from '@/views/system/add.vue';
import AddJingDian from "@/views/jingdian/add/add.vue";
import EditJingDian from "@/views/jingdian/edit/add.vue";
import Jingdian from "@/views/jingdian/index.vue";
import UserSelf from '@/views/user/self/add.vue';


const routers: RouteRecordRaw[] = [ // 二级路由页面
    {
        path: '/user/usermanager',
        name: 'usermanager',
        component: UserManager,
        meta: {
            title: '用户管理',
        },
    },
    {
        path: '/user/self',
        name: 'userself',
        component: UserSelf,
        meta: {
            title: '个人中心',
        },
    },
    {
        path: '/user/jifenduihuan',
        name: 'jifenduihuan',
        component: Jifenduihuan,
        meta: {
            title: '积分兑换审核',
        },
    },
    {
        path: '/jingling/goodsadd',
        name: 'goodsadd',
        component: AddGoods,
        meta: {
            title: '添加精灵',
        },
    },
    {
        path: '/jingling/edit',
        name: 'goodsedit',
        component: EditShop,
        meta: {
            title: '修改精灵',
        },
    },

    {
        path: '/jingling/manager',
        name: 'goodsmanager',
        component: GoodsManager,
        meta: {
            title: '精灵管理',
        },
    },
    {
        path: '/jingdian/add',
        name: 'jingdianadd',
        component: AddJingDian,
        meta: {
            title: '添加精灵',
        },
    },
    {
        path: '/jingdian/edit',
        name: 'jingdianedit',
        component: EditJingDian,
        meta: {
            title: '修改精灵',
        },
    },

    {
        path: '/jingdian/manager',
        name: 'jingdiansmanager',
        component: Jingdian,
        meta: {
            title: '精灵管理',
        },
    },
    {
        path: '/system/manager',
        name: 'systemmanager',
        component: System,
        meta: {
            title: '系统配置',
        },
    },
    {
        path: '/order/manager',
        name: 'ordermanager',
        component: Order,
        meta: {
            title: '兑换记录',
        },
    },
    {
        path: '/index',
        name: 'index',
        component: Index,
        meta: {
            title: '首页',
        },
    },
    {
        path: '/404',
        name: '404',
        component: Page404,
        meta: {
            title: '页面丢失了',
        }
    }
];


const routes: RouteRecordRaw[] = [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: '首页',
            },
            children: routers
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: '登录',
            },
        },
    ]
;

const router = createRouter({
    // @ts-ignore
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

const isInRouter = (path: string, route: RouteRecordRaw[]) => {
    if (path == '/') {
        return false;
    }
    let is404 = true;
    route.forEach(item => {
        if (!item.children) {
            if (item.path == path) {
                is404 = false;
            }
        } else {
            is404 = isInRouter(path, item.children!!);
        }
        if (!is404) {
            return;
        }
    });
    return is404;
};

router.beforeEach((to, from, next) => {
    if (isInRouter(to.path, routes)) {
        return next('/404');
    }

    if (!StorageUtil.token) {
        if (to.path !== '/login') {
            ElMessage.warning({
                message: '请先登录哦',
                showClose: true,
                type: 'warning'
            });
            return next('/login');
        }
    }
    if (to.meta.title) {
        const title: any = to.meta.title;
        document.title = '管理后台-' + title;
    }
    if (to.path == '/index' && from.path != '/') {
        return next(from);
    }
    next();
});

export default router;
